export const baseWords_ru = {
btns: {
    stand3D: 'Перейти на 3D стенд'
},
errorText: {
    message: 'Неизвестная ошибка'
}
}